export default __webpack_public_path__ + "static/media/logo.7ff4c955.png";